import Rails from "@rails/ujs";
Rails.start();

import "../controllers";
